import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import AdminMatrix from "@/pages/AdminMatrix";
import OperatorWorkspace from "@/pages/OperatorWorkspace";
import ClientPortal from "@/pages/ClientPortal";
import SystemAudit from "@/pages/SystemAudit";
import ReportingPage from "@/pages/ReportingPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import ProtectedRoute from "@/components/ProtectedRoute";

function DashboardRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  const roleRoutes = {
    "super-admin": "/admin",
    admin: "/admin",
    operator: "/operator",
    client: "/client",
  };
  return <Navigate to={roleRoutes[user.role] || "/operator"} replace />;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardRedirect /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={["super-admin", "admin"]}><AdminMatrix /></ProtectedRoute>} />
      <Route path="/operator" element={<ProtectedRoute roles={["super-admin", "admin", "operator"]}><OperatorWorkspace /></ProtectedRoute>} />
      <Route path="/client" element={<ProtectedRoute roles={["super-admin", "admin", "client"]}><ClientPortal /></ProtectedRoute>} />
      <Route path="/audit" element={<ProtectedRoute roles={["super-admin"]}><SystemAudit /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute roles={["super-admin", "admin", "client"]}><ReportingPage /></ProtectedRoute>} />
      <Route path="/leaderboard" element={<ProtectedRoute roles={["super-admin", "admin"]}><LeaderboardPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </LanguageProvider>
  );
}
